import React from 'react';
import { ProtectedViewProvider } from './src/context-providers/protection-provider';
import { Theme } from './src/styles/theme';

export const wrapRootElement = ({ element }) => (
    <Theme>
        <ProtectedViewProvider>{element}</ProtectedViewProvider>
    </Theme>
);
